import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { TemplateType } from './types/template-type.type';

/**
 * Fetches the available template types from the API.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing an array of {@link TemplateType}.
 * @throws Throws an error if the request fails.
 */
export const getTemplateTypes = async (instance: KyInstance) => {
  try {
    return await instance.get<OperationResultWithData<TemplateType[]>>(Uri.template.getTemplateTypes).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
